module.exports = __webpack_public_path__ + "static/NexusLogo-a02099bc3f0388b2318a2989f868c739.png";